import React from "react";

const ReportOfTheCouncil = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">Report of the Council</h1>
      <p className="mt-4">
        The Council has the pleasure of presenting the report together with the
        financial statements for the year ended 31st December, 2023 which
        disclose the sources, utilization and balances of cash for Mwansabombwe
        Town Council during the period under review.
      </p>
    </div>
  );
};

const BackgroundAndLocation = () => {
  return (
    <div className="p-6 mt-6 border-t">
      <h2 className="text-xl font-bold">Background and Location of the Council</h2>
      <p className="mt-4">
        Mwansabombwe Town Council was established and given a district council
        status in July, 2012. It was delineated from Kawambwa District and is
        located in Kazembe along the valley of the Luapula River, on the
        northern part of Luapula Province. Mwansabombwe is 182 Km from the
        provincial capital, Mansa and 940 Km from the nation’s capital, Lusaka.
      </p>
      
      <p>
      Mwansabombwe District is located within longitudes 28º 30´ and 29º 0´ east of the Greenwich Meridian and latitudes 9º 41´ and 10º 9´ south of the Equator. The rainfall pattern in the area is good for farming activities for crops like maize and cassava. It shares boundaries with Nchelenge District in the north, Mwense District in the south, the Democratic Republic of the Congo (DRC) in the west and Kawambwa District in the east. The district covers an area of approximately 1,200 Square kilometres Km², which is 2.4% of the Total area of Luapula Province. Out of the 1,200 km², only 64  km²  make up state land and the remaining 1136 km² is customary land under the traditional leadership of his Royal Highness Mwata Kazembe.
      </p>

      <p>
      Mwansabombwe has a very rich cultural heritage, most notably the famous Umutomboko traditional ceremony, which attracts a huge number of people including local and international tourists and uplifts the economy of the district. It is held annually on the last Saturday of July.
      </p>

      <p>
      The Kazembe Kingdom was established during the 1740s. During the height of its power in the 1800s, the Kazembe Kingdom occupied a vast territory including parts of the Katanga region of Congo and northern part of Zambia during the reign of the greatest ruler, Kazembe II, named Kaniembo, who conquered most territories and established his capital at Kazembe. It became the centre of trade between the people in the African interior and the Portuguese and Arabs in the eastern coast.
      </p>
      <p>
      Mwansabombwe District has linear type of settlements. The Census of Population undertaken by the Zambia Statistics Agency in 2022 reveled that the population of Mwansabombwe District had reached 58,919 comprising of 30,375 female representing 52 per cent of the Total population and 28,546 male representing 48 per cent, respectively (CSO, 2012). Making it the Eighth (8th ) most populous district in the province after Mansa -327,063, Nchelenge - 233,696, Chienge - 189,893, Samfya- 147,189, Kawambwa- 123,652, Mwense - 122,605 and  Chifunabuli - 116,326 respectively. The population density was about 49 persons per square kilometre way above the national average of 17.4 and the regional average of 19.6 persons per square kilometre. The population growth was estimated at an average of 2.2 per cent per annum from 45,294 in 2010 to 58,919 in 2022 (ZSA, 2012).
      </p>

      <p>
      The postal address of the registered office of Mwansabombwe Town Council (MTC) is as follows:
        <br/>
        The Civic Centre<br/>
        P.O Box 750002<br/>
        Kazembe<br/>
        MWANSABOMBWE<br/>
      </p>
    </div>
  );
};

const CompositionOfTheCouncil = () => {
  return (
    <div className="p-6 mt-6 border-t">
      <h2 className="text-xl font-bold">Composition of the Council</h2>
      <p className="mt-4">
        Mwansabombwe Town Council is a corporate body established under Article
        152 of the Constitution of Zambia (Amendment) Act No. 2 of 2016 and
        section 6 of the Local Government Act No. 2 of 2019, mandated to
        perform functions, among them, service delivery to the community and
        policy making.
      </p>
      <p>
      The Council is composed of an elected Chairperson, Twelve (12) elected councilors in each ward and a chief representative as provided for under Article 153 (2) (c) of the Constitution of Zambia (Amendment) Act No. 2 of 2016. The current Council Chairperson was elected to office in 2021 to serve a five year term up to 2026. The Vice Council Chairperson was elected from among the Councillors in 2021 for the period of two and half years.
      </p>

      <p>
      The district has only one constituency namely, Mwansabombwe which is comprised of twelve (12) wards named as Mununshi, Mulele, Salanga, Lufubu, Mwansabombwe, Kazembe, Chipita, Kayo, Kakose, Pembe, Kabalenge and Mbereshi Wards. 
      </p>

      <p>
      The Councillors who held office during the year were;
      <table>
        <thead>
            <tr>
                <th>ٍS/N</th>
                <th>NAME</th>
                <th>GENDER</th>
                <th>POSITION</th>
                <th>WARD</th>
            </tr>
        </thead>

        <tbody>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </tbody>
      </table>
      </p>

      <p>
      The District also has one (1) elected Member of Parliament for Mwansabombwe Constituency. The Member of Parliament that held office during the year was:

        <div className="flex justify-between my-5">
            <span>NAME</span>
            <span>GENDER</span>
            <span>CONSTITUENCY</span>
        </div>

        The affairs of Central Government in the district are coordinated by the District Commissioner. During the year under review Mrs Rosemary Chikonde Mwiche  was the District Commissioner for Mwansabombwe District.
      
      </p>
    </div>
  );
};

const StatementOfResponsibilities = () => {
  return (
    <div className="p-6 mt-6 border-t">
      <h2 className="text-xl font-bold">STATEMENT OF RESPONSIBILITIES FOR ANNUAL FINANCIAL STATEMENTS</h2>
      <p className="mt-4">
      The Mwansabombwe Town Council is responsible for preparing the financial statements for the year ended 31st December, 2023 which are free from material misstatement, whether due to fraud or error, and are prepared, in all material respects, in accordance with the Cash Basis International Public Sector Accounting Standard (IPSAS). In preparing the financial statements, the Council selected applicable policies from Amended Local Authorities Accounting Policies (LAAPs) No. 2 of 2022 and then applied them consistently, making judgment and estimates that were reasonable and prudent.
      </p>
      
      <p>
      The Council is also responsible for the maintenance of adequate accounting records and the preparation and integrity of the annual financial statements and related information. The Auditor-General has audited the financial statements and his report is shown on pages 6 to 8.
      </p>

      <p>
      The Council accepts responsibility for the annual financial statements, which have been prepared using appropriate accounting policies supported by reasonable estimates, in conformity with the Cash Basis IPSAS, the requirements of the Local Government Act No. 2 of 2019, the Public Finance Management Act No. 1 of 2018 and Amended Local Authorities Accounting Policies (LAAPs) No. 2 of 2022.  
      </p>

      <p>
      The Council further accepts responsibility:
        <ul>
            <li>for the maintenance of accounting records that may be relied upon in the preparation of financial statements,</li>
            <li>for designing, implementing and maintaining systems of internal controls relevant to the preparation and fair presentation of financial statements that are free from material misstatement, whether due to fraud or error.</li>
        </ul>

        Nothing has come to the attention of the Council to indicate that the Mwansabombwe Town Council will not remain a going concern for at least twelve months from the date of this statement.

        <br />
        In the opinion of the Council, proper books of accounts were maintained to support preparation of Financial Statements that present fairly the financial results of the Mwansabombwe Town Council for the financial year ended 31st December, 2023.	
      </p>

      <p>
      Signed on behalf of the Council on ............................. by; <br />

                Name: ....................................		<br />
            Signature: ..................................<br />

            Position: Council Chairperson	<br /><br />

            Name: ....................................<br />

            Signature: .............................<br />

            Position: Council Secretary<br /><br />


            Name: .......................................<br />


            Signature ...........................	<br />			

            Position: Director Finance	<br />	

      </p>
    </div>
  );
};

const ReportPage = () => {
  return (
    <div className="container mx-auto my-6 bg-white">
      <ReportOfTheCouncil />
      <BackgroundAndLocation />
      <CompositionOfTheCouncil />
      <StatementOfResponsibilities />
      {/* Include other sections as necessary */}
    </div>
  );
};

export default ReportPage;
